// Palette

// Chart options
export const options = {
  responsive: true,
  maintainAspectRatio: false,
  animation: false,
  layout: {padding: 0},
};
